import {BenjiKIVGameAssets} from "../BenjiKIVGameAssets";
import {BenjiKIV} from "../BenjiKIV";
import {gsap} from "gsap";
import {BenjiKIVSound} from "../sound/BenjiKIVSound";
import {SpineUtils} from "../utils/SpineUtils";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";

/**
 * Created by Jerker Nord on 2022-12-01.
 */

export class BenjiKIVOverlayScatterSymbol extends PIXI.Container {

    private static MULTIPLIER_POSITION:PIXI.Point = new PIXI.Point(-16, 0);
    private static ANIMATION_NAMES:string[] = ["In", "Idle", "Hit_1", "Hit_2", "Hit_3", "Out", "Dead", "Wake_Up", "Idle2", "Idle3", "Hit_Split", "Dead_Out"];
    private static DIGITS_SCALE_VALUE:number[] = [1, 0.68, 0.54, 0.44, 0.35];

    private _multiplierValue:number;
    private _multiplierText:PIXI.BitmapText;
    private _index:number;
    //The reel and row of the overlay
    private _overlayPosition:PIXI.Point;
    private _currentMultiplierScaleSize:number = 1;
    private _isUsed:boolean;
    private _overlayAnimation:PIXI.spine.Spine;
    private _updateLevel1TL:gsap.core.Timeline;
    private _updateLevel2TL:gsap.core.Timeline;
    private _updateLevel3TL:gsap.core.Timeline;
    private _updateLevel1DoubleTL:gsap.core.Timeline;
    private _updateLevel2DoubleTL:gsap.core.Timeline;
    private _updateLevel3DoubleTL:gsap.core.Timeline;
    private _outAnimationTL:gsap.core.Timeline;
    private _outDeadAnimationTL:gsap.core.Timeline;
    private _initTL:gsap.core.Timeline;
    private _isDead:boolean = false;
    private _idleLevel:number = 1;

    constructor() {
        super();
        this.init();
    }

    private init():void {
        this._overlayAnimation = new PIXI.spine.Spine(BenjiKIV.assetLoader.getSpineAsset(BenjiKIVGameAssets.SCATTER_OVERLAY_SPINE));
        this._overlayAnimation.visible = false;
        this.addChild(this._overlayAnimation);

        this.isUsed = false;
        this.visible = false;

        this.overlayPosition = new PIXI.Point();

        this._multiplierText = new PIXI.BitmapText("0x", {
            fontName : BenjiKIVGameAssets.BITMAP_FONT_SYMBOL_MULTIPLIER,
            fontSize : 70
        });
        this._multiplierText.anchor = new PIXI.Point(0.5, 0.5);
        this._multiplierText.position = BenjiKIVOverlayScatterSymbol.MULTIPLIER_POSITION;
        this.addChild(this._multiplierText);

        this._updateLevel1TL = gsap.timeline({paused : true});
        this._updateLevel1TL.add(new SpineTween(this._overlayAnimation, 0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[2]))
        this._updateLevel1TL.add(() => {this._overlayAnimation.state.setAnimation(0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[1], true)});
        this._updateLevel1TL.add(() => {this._idleLevel = 1});

        this._updateLevel1DoubleTL = gsap.timeline({paused : true});
        this._updateLevel1DoubleTL.add(new SpineTween(this._overlayAnimation, 0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[10]))
        this._updateLevel1DoubleTL.add(() => {this._overlayAnimation.state.setAnimation(0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[1], true)});
        this._updateLevel1DoubleTL.add(() => {this._idleLevel = 1});

        this._updateLevel2TL = gsap.timeline({paused : true});
        this._updateLevel2TL.add(new SpineTween(this._overlayAnimation, 0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[3]))
        this._updateLevel2TL.add(() => {this._overlayAnimation.state.setAnimation(0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[8], true)});
        this._updateLevel2TL.add(() => {this._idleLevel = 8});

        this._updateLevel2DoubleTL = gsap.timeline({paused : true});
        this._updateLevel2DoubleTL.add(new SpineTween(this._overlayAnimation, 0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[10]))
        this._updateLevel2DoubleTL.add(() => {this._overlayAnimation.state.setAnimation(0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[8], true)});
        this._updateLevel2DoubleTL.add(() => {this._idleLevel = 8});

        this._updateLevel3TL = gsap.timeline({paused : true});
        this._updateLevel3TL.add(new SpineTween(this._overlayAnimation, 0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[4]))
        this._updateLevel3TL.add(() => {this._overlayAnimation.state.setAnimation(0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[9], true)})
        this._updateLevel3TL.add(() => {this._idleLevel = 9});

        this._updateLevel3DoubleTL = gsap.timeline({paused : true});
        this._updateLevel3DoubleTL.add(new SpineTween(this._overlayAnimation, 0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[10]))
        this._updateLevel3DoubleTL.add(() => {this._overlayAnimation.state.setAnimation(0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[9], true)})
        this._updateLevel3DoubleTL.add(() => {this._idleLevel = 9});

        this._outAnimationTL = gsap.timeline({paused : true});
        this._outAnimationTL.add([
            gsap.to(this._multiplierText, {duration : 0.4, alpha : 0, delay : 0.2}),
            () => SpineUtils.resetSpineAnimation(this._overlayAnimation),
            new SpineTween(this._overlayAnimation, 0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[5]),
            this.getARoomAnimation()
        ]);
        this._outAnimationTL.add(() => {
            this.visible = false;
            this.isUsed = false;
            this._multiplierText.alpha = 1;
            this._multiplierText.position.y = 0;
        });

        this._outDeadAnimationTL = gsap.timeline({paused : true});
        this._outDeadAnimationTL.add([
            gsap.to(this._multiplierText, {duration : 0.4, alpha : 0, delay : 0.2}),
            () => SpineUtils.resetSpineAnimation(this._overlayAnimation),
            new SpineTween(this._overlayAnimation, 0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[11]),
            this.getARoomAnimation()
        ]);
        this._outDeadAnimationTL.add(() => {
            this.visible = false;
            this.isUsed = false;
            this._multiplierText.alpha = 1;
            this._multiplierText.position.y = 0;
        });
    }

    public initMultiplier(value:number):void {
        this._multiplierValue = value;
        this._multiplierText.text = value.toString() + "x";
        const targetScaleSize:number = BenjiKIVOverlayScatterSymbol.DIGITS_SCALE_VALUE[value.toString().length - 1];
        this._multiplierText.scale.set(targetScaleSize, targetScaleSize);
    }

    public playOutAnimation(timeScale:number):void {
        if (this._initTL && this._initTL.isActive()){
            this._initTL.pause();
            this._initTL.kill();
        }
        if(this._isDead == true) {
            this._outDeadAnimationTL.restart().timeScale(timeScale);
        } else {
            this._outAnimationTL.restart().timeScale(timeScale);
        }
    }

    public setNoWin():void {
        this._isDead = true;
        this._overlayAnimation.state.setAnimation(0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[6], false);
        this._multiplierText.alpha = 0.25;
    }

    public wakeUp():void {
        if(this._isDead == true) {
            this._isDead = false;
            const wakeUpTL:gsap.core.Timeline = gsap.timeline();
            wakeUpTL.add([
                new SpineTween(this._overlayAnimation, 0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[7]),
                () => {this._multiplierText.alpha = 1;}
            ]);
            wakeUpTL.add(() => {this._overlayAnimation.state.setAnimation(0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[this._idleLevel], true)});
        }
    }

    public wakeUpToIdle():void {
        if(this._isDead == true) {
            this._isDead = false;
            this._multiplierText.alpha = 1;
            this._overlayAnimation.state.setAnimation(0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[this._idleLevel], true);
        }
    }

    public getInitAnimation():gsap.core.Timeline {
        if (this._outAnimationTL.isActive()){
            this._outAnimationTL.pause();
        }
        if (this._outDeadAnimationTL.isActive()){
            this._outDeadAnimationTL.pause();
        }
        this.isDead = false;
        this._initTL = gsap.timeline();
        this._initTL.add(() => {this._overlayAnimation.visible = true});
        this._initTL.add(() => {SpineUtils.resetSpineAnimation(this._overlayAnimation)});
        this._initTL.add(new SpineTween(this._overlayAnimation, 0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[0]));
        this._initTL.add(() => {this._overlayAnimation.state.setAnimation(0, BenjiKIVOverlayScatterSymbol.ANIMATION_NAMES[1], true)});
        return this._initTL;
    }

    public getMakeRoomAnimation():gsap.core.Timeline {
        const makeRoomTL:gsap.core.Timeline = gsap.timeline();
        makeRoomTL.add(() => {
            if(this._multiplierValue.toString().length < 2) {
                gsap.to(this._multiplierText.scale, 0.2, {
                    x : BenjiKIVOverlayScatterSymbol.DIGITS_SCALE_VALUE[1],
                    y : BenjiKIVOverlayScatterSymbol.DIGITS_SCALE_VALUE[1]
                })
            }
            gsap.to(this._multiplierText.position, 0.2, {
                y : 44,
                x : -10
            })
        })
        return makeRoomTL;
    }

    public getARoomAnimation():gsap.core.Timeline {
        const getARoomTL:gsap.core.Timeline = gsap.timeline();
        getARoomTL.add(() => {
            if(this._multiplierValue.toString().length < 2) {
                gsap.to(this._multiplierText.scale, 0.3, {
                    x : BenjiKIVOverlayScatterSymbol.DIGITS_SCALE_VALUE[0],
                    y : BenjiKIVOverlayScatterSymbol.DIGITS_SCALE_VALUE[0]
                })
            }
            gsap.to(this._multiplierText.position, 0.3, {
                y : 0,
                x : BenjiKIVOverlayScatterSymbol.MULTIPLIER_POSITION.x
            })
        })
        return getARoomTL;
    }

    public getUpdateMultiplierTL(value:number, playUpgradeSound:boolean = true):gsap.core.Timeline {
        const targetScaleSize:number = BenjiKIVOverlayScatterSymbol.DIGITS_SCALE_VALUE[value.toString().length - 1];
        const updateMultiTL:gsap.core.Timeline = gsap.timeline();
        let isDoubled:boolean = false;
        if((value / this._multiplierValue == 2) && this._multiplierValue > 9) {
            //Xsplit doubling and value before doubling is 10 or more
            isDoubled = true;
        }
        if(value.toString() == this._multiplierText.text) {
            return updateMultiTL;
        }
        updateMultiTL.add(() => {this._multiplierText.visible = true});
        updateMultiTL.add(() => {this._multiplierText.alpha = 1});
        if(playUpgradeSound == true) {
            updateMultiTL.add(() => {BenjiKIV.soundPlayer.playSound(BenjiKIVSound.MULTI_UPGRADE)});
        }
        updateMultiTL.add([
            gsap.to(this._multiplierText.scale, 0.3, {
                x : this._currentMultiplierScaleSize * 1.2,
                y : this._currentMultiplierScaleSize * 1.2
            }),
            () => {
                if(value < 20) {
                    if(isDoubled == true) {
                        this._updateLevel1DoubleTL.restart();
                    } else {
                        this._updateLevel1TL.restart();
                    }
                } else if(value < 50) {
                    if(isDoubled == true) {
                        this._updateLevel2DoubleTL.restart();
                    } else {
                        this._updateLevel2TL.restart();
                    }
                } else {
                    if(isDoubled == true) {
                        this._updateLevel3DoubleTL.restart();
                    } else {
                        this._updateLevel3TL.restart();
                    }
                }
            }
        ]);
        updateMultiTL.add(() => {
            this._multiplierValue = value;
            this._multiplierText.text = value.toString() + "x";
        })
        updateMultiTL.add(gsap.to(this._multiplierText.scale, 0.2, {
            x : targetScaleSize * 0.9,
            y : targetScaleSize * 0.9
        }));
        updateMultiTL.add(gsap.to(this._multiplierText.scale, 0.1, {
            x : targetScaleSize,
            y : targetScaleSize
        }));
        updateMultiTL.add(() => {
            this._currentMultiplierScaleSize = targetScaleSize;
        })

        return updateMultiTL;
    }

    public setToInitMultiplier():gsap.core.Timeline {
        return this.getUpdateMultiplierTL(this._index, false);
    }

    public reset():void {
        this._idleLevel = 1;
    }

    get multiplierValue():number {
        return this._multiplierValue;
    }

    get index():number {
        return this._index;
    }

    set index(value:number) {
        this._index = value;
    }

    get overlayPosition():PIXI.Point {
        return this._overlayPosition;
    }

    set overlayPosition(value:PIXI.Point) {
        this._overlayPosition = value;
    }

    get isUsed():boolean {
        return this._isUsed;
    }

    set isUsed(value:boolean) {
        this._isUsed = value;
        if(value == false) {
            this.reset();
        }
    }

    get isDead():boolean {
        return this._isDead;
    }

    set isDead(value:boolean) {
        this._isDead = value;
    }
}